import { render, staticRenderFns } from "./ArticleTeaser.vue?vue&type=template&id=7a4dd0ed&scoped=true&"
import script from "./ArticleTeaser.js?vue&type=script&lang=js&"
export * from "./ArticleTeaser.js?vue&type=script&lang=js&"
import style0 from "./ArticleTeaser.scss?vue&type=style&index=0&id=7a4dd0ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4dd0ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LazyImage: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/LazyImage/LazyImage.vue').default})
